import React from 'react';
import Broad from '../Broad';
type Props = {};

const BroadContainer = (props: Props) => {
  return <Broad />;
};

export default BroadContainer;
